import { AdvancedFilterDataSchema } from "@redotech/redo-model/views/views";
import * as z from "zod/v4";

export const getProductVendors = {
  name: "getProductVendors" as const,
  input: z.object({
    search: z.string().optional(),
    advancedFiltersData: z.array(AdvancedFilterDataSchema).optional(),
  }),
  output: z.object({ vendors: z.array(z.string()) }),
};
